// Find a unique display name for a duplicated entry: "<base> copy", then
// "<base> copy 2", "<base> copy 3", … until one isn't already taken. Shared by
// the surfaces whose entries are keyed by name (rules documents, battle tactics).
export function uniqueName(base: string, taken: Iterable<string>, suffix = 'copy'): string {
  const set = taken instanceof Set ? taken : new Set(taken);
  let candidate = `${base} ${suffix}`;
  let n = 2;
  while (set.has(candidate)) {
    candidate = `${base} ${suffix} ${n}`;
    n++;
  }
  return candidate;
}
